export const sessionStorageSetItem = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value))
}

export const sessionStorageRemoveItem = (key) => {
  sessionStorage.removeItem(key)
}

export const sessionStorageGetItem = (key) => {
  return JSON.parse(sessionStorage.getItem(key))
}
